/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OptionalMapInputConversationTypeTemplateKindDtoString } from './optional-map-input-conversation-type-template-kind-dto-string';
import {
    OptionalMapInputConversationTypeTemplateKindDtoStringFromJSON,
    OptionalMapInputConversationTypeTemplateKindDtoStringFromJSONTyped,
    OptionalMapInputConversationTypeTemplateKindDtoStringToJSON,
    OptionalMapInputConversationTypeTemplateKindDtoStringToJSONTyped,
} from './optional-map-input-conversation-type-template-kind-dto-string';

/**
 * 
 * @export
 * @interface ConversationTypePatchRequest
 */
export interface ConversationTypePatchRequest {
    /**
     * Unique identifier for a conversation type.
     * @type {string}
     * @memberof ConversationTypePatchRequest
     */
    id?: string | null;
    /**
     * A description of what this conversation type is used for.
     * @type {string}
     * @memberof ConversationTypePatchRequest
     */
    description?: string | null;
    /**
     * If set, all user participants will appear as the same user in the conversation to client participants.
     * @type {string}
     * @memberof ConversationTypePatchRequest
     */
    displayNameSharedByUsers?: string | null;
    /**
     * If set, all user participants share the read status
     * @type {boolean}
     * @memberof ConversationTypePatchRequest
     */
    sharedReadStatusForUserParticipants?: boolean | null;
    /**
     * If set, all workflow participants will appear with this name in the conversation to client participants.
     * @type {string}
     * @memberof ConversationTypePatchRequest
     */
    displayNameForWorkflowParticipants?: string | null;
    /**
     * A JSON Schema describing the data expected in the conversation.
     * @type {string}
     * @memberof ConversationTypePatchRequest
     */
    conversationDataSchema?: string | null;
    /**
     * A handlebars template string used to render the conversation data in a list view. The template can contain placeholders for data in the conversation data schema, or one of the allowed values: conversation_id, conversation_description, conversation_unread_count.
     * @type {string}
     * @memberof ConversationTypePatchRequest
     */
    conversationDataListItemTemplate?: string | null;
    /**
     * An HTML template to reader the header in the client app which has dynamic values based on the conversation_data
     * @type {string}
     * @memberof ConversationTypePatchRequest
     */
    clientAppHeaderTemplate?: string | null;
    /**
     * If set, the SMS messages will have this value as sender
     * @type {string}
     * @memberof ConversationTypePatchRequest
     */
    smsSenderId?: string | null;
    /**
     * A map of template types to template names. If not provided, system default templates will be used.
     * @type {OptionalMapInputConversationTypeTemplateKindDtoString}
     * @memberof ConversationTypePatchRequest
     */
    messageTemplates?: OptionalMapInputConversationTypeTemplateKindDtoString | null;
    /**
     * The number of days conversations of this type will be retained before automatic deletion.
     * @type {number}
     * @memberof ConversationTypePatchRequest
     */
    retentionPolicyDays?: number | null;
}

/**
 * Check if a given object implements the ConversationTypePatchRequest interface.
 */
export function instanceOfConversationTypePatchRequest(value: object): value is ConversationTypePatchRequest {
    return true;
}

export function ConversationTypePatchRequestFromJSON(json: any): ConversationTypePatchRequest {
    return ConversationTypePatchRequestFromJSONTyped(json, false);
}

export function ConversationTypePatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationTypePatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'displayNameSharedByUsers': json['display_name_shared_by_users'] == null ? undefined : json['display_name_shared_by_users'],
        'sharedReadStatusForUserParticipants': json['shared_read_status_for_user_participants'] == null ? undefined : json['shared_read_status_for_user_participants'],
        'displayNameForWorkflowParticipants': json['display_name_for_workflow_participants'] == null ? undefined : json['display_name_for_workflow_participants'],
        'conversationDataSchema': json['conversation_data_schema'] == null ? undefined : json['conversation_data_schema'],
        'conversationDataListItemTemplate': json['conversation_data_list_item_template'] == null ? undefined : json['conversation_data_list_item_template'],
        'clientAppHeaderTemplate': json['client_app_header_template'] == null ? undefined : json['client_app_header_template'],
        'smsSenderId': json['sms_sender_id'] == null ? undefined : json['sms_sender_id'],
        'messageTemplates': json['message_templates'] == null ? undefined : OptionalMapInputConversationTypeTemplateKindDtoStringFromJSON(json['message_templates']),
        'retentionPolicyDays': json['retention_policy_days'] == null ? undefined : json['retention_policy_days'],
    };
}

export function ConversationTypePatchRequestToJSON(json: any): ConversationTypePatchRequest {
    return ConversationTypePatchRequestToJSONTyped(json, false);
}

export function ConversationTypePatchRequestToJSONTyped(value?: ConversationTypePatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'display_name_shared_by_users': value['displayNameSharedByUsers'],
        'shared_read_status_for_user_participants': value['sharedReadStatusForUserParticipants'],
        'display_name_for_workflow_participants': value['displayNameForWorkflowParticipants'],
        'conversation_data_schema': value['conversationDataSchema'],
        'conversation_data_list_item_template': value['conversationDataListItemTemplate'],
        'client_app_header_template': value['clientAppHeaderTemplate'],
        'sms_sender_id': value['smsSenderId'],
        'message_templates': OptionalMapInputConversationTypeTemplateKindDtoStringToJSON(value['messageTemplates']),
        'retention_policy_days': value['retentionPolicyDays'],
    };
}

